import {
  Box,
  Chip,
  Typography,
  Stack,
  IconButton,
  Button,
  Tooltip,
  useMediaQuery,
  useTheme,
  Modal,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import { FC, useState } from "react";
import heart_card from "../../../../assets/heart_card.png";
import spade_card from "../../../../assets/spade_card.png";
import ColouredSuitLogo from "../../../../Profile/TalentInfo/ColouredSuitLogo";
import CoinTimeRating from "../../../../Profile/TalentInfo/CoinTimeRating";
import dayjs from "dayjs";
import CloverCardStrip from "../../../../Profile/TalentInfo/CloverCardStrip";
import DiamondCardStrip from "../../../../Profile/TalentInfo/DiamondCardStrip";
import { Popover } from "@material-ui/core";
import UserCardContents from "./UserCardContents";

export interface Card {
  id: string;
  title: string;
  description: string;
  suit: string;
  categories?: string;
  price: number;
  duration: number;
  primary_thumbnail?: File | undefined | string | null;
  talent?: any;
  startDateTime?: string;
  product_type?: string;
  product?: any;
  gtp?: any;
  allow_instance_booking:  boolean | undefined
}

export interface TalentCardProps {
  card: Card;
  isHovered?: boolean;
  onClickViewDetail?: () => void;
  onHover?: (hovering: boolean) => void;
  onClickBooKNow?: () => void;
  onBookMark?: (card_id?: string) => void;
  bookmarkedCardIds?: string[];
  onAddtoDeck?: (card_id?: string) => void;
  myDeckCardIds?: string[];
  fromAddToDeck?: boolean;
  // talent
  isTalent?: boolean;
  onClickByTalent?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onDeactivate?: () => void;
}

export const CardDesign: FC<TalentCardProps> = ({
  card,
  isHovered = false,
  fromAddToDeck = false,
  onClickViewDetail,
  onHover,
  onClickBooKNow,
  onBookMark,
  bookmarkedCardIds,
  onAddtoDeck,
  myDeckCardIds,
  isTalent,
  onClickByTalent,

}) => {
  const theme = useTheme();
  // const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  // const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  // const isMd = useMediaQuery(theme.breakpoints.only("md"));
  // const isLg = useMediaQuery(theme.breakpoints.only("lg"));
  // const isXl = useMediaQuery(theme.breakpoints.only("xl"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    suit,
    categories,
    title,
    description,
    price,
    duration,
    primary_thumbnail,
    talent,
    startDateTime,
    product_type,
  } = card;

  const parsedCategories = categories?.split(",").map((c) => c.trim()) || [];

  const [isMobileCardOpen, setIsMobileCardOpen] = useState(false);

  return (
    <Box
      sx={{
        width: {
          xs: "100%",
          sm: "100%",
          md: "100%",
        },
        maxWidth: {
          xxs: 340,
          xs: 360,
          sm: 360,
          md: 380,
        },
      }}
      onMouseEnter={() => onHover?.(true)}
      onMouseLeave={() => onHover?.(false)}
      // onClick={() => (isMobile ? setIsMobileCardOpen(true) : {})} //to open modal of card in mobile view
      onClick={() => {
        if (isMobile) {
          onClickViewDetail?.();
        }
      }}
    >
      <UserCardContents
        card={card}
        bookmarkedCardIds={bookmarkedCardIds}
        isHovered={isHovered}
        myDeckCardIds={myDeckCardIds}
        onBookMark={onBookMark}
        onAddtoDeck={onAddtoDeck}
        onClickViewDetail={onClickViewDetail}
        fromAddToDeck={fromAddToDeck}
        isTalent={isTalent}
        onClickByTalent={onClickByTalent}
        product_type={isTalent ? card?.product?.type : product_type}
      />

      <Modal
        open={isMobileCardOpen}
        onClose={() => setIsMobileCardOpen(false)}
        closeAfterTransition
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          onClick={(e) => e.stopPropagation()}
          sx={{
            backgroundColor: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "90%",
            position: "relative",
            padding: "20px",
            borderRadius: "8px",
          }}
        >
          <IconButton
            onClick={(e) => {
              e.stopPropagation(); // 🔐 Also prevent close button from re-triggering card click
              setIsMobileCardOpen(false);
            }}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>
          <UserCardContents
            card={card}
            bookmarkedCardIds={bookmarkedCardIds}
            isHovered={isHovered}
            myDeckCardIds={myDeckCardIds}
            onBookMark={onBookMark}
            onAddtoDeck={onAddtoDeck}
            onClickViewDetail={onClickViewDetail}
            fromAddToDeck={fromAddToDeck}
            isTalent={isTalent}
            onClickByTalent={onClickByTalent}
            product_type={product_type}
            isMobileViewModal
          />
        </Box>
      </Modal>
    </Box>
  );
};
